import { create } from 'zustand';

interface SubscriptionModalState {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useSubscriptionModalStore = create<SubscriptionModalState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}));

